import { createI18n } from 'vue-i18n'
import zh_cn from '@/languages/zh-cn'
import en from '@/languages/en'

const i18n = createI18n({
  legacy: false, // 让 setup 函数可以通过 t 访问
  globalInjection: true, // 让 template 可以像 vue2 那样使用 $t 来访问
  locale: 'zh-cn',
  fallbackLocale: 'zh-cn',
  messages: {
    'zh-cn': zh_cn,
    'en': en
  }
})

const tc = (key)=>{
  return i18n.global.t(key);
}

export {i18n,tc} 